module.exports = __webpack_public_path__ + "static/AlbertusMTStd-Light-27d56f7e76916abf8ec2d936f06e24d7.woff";